import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProcurementApiResponse, ProcurementPurchaseOrderPageResponse, ProcurementPurchaseOrderRequest, ProcurementPurchaseOrderResponse, ProcurementPurchaseOrderTypeResponse } from "../model/purchase-order.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class ProcurementPurchaseOrdersService {
  private readonly ordersUrl: string;
  private readonly typesUrl: string;
  constructor(private readonly http: HttpClient, @Inject(BASE_PATH) basePath: string) {
    const base = basePath.replace(/\/$/, "");
    this.ordersUrl = `${base}/api/v1/purchase-orders`;
    this.typesUrl = `${base}/api/v1/purchase-order-types`;
  }
  listTypes(active = true): Observable<ProcurementApiResponse<ProcurementPurchaseOrderTypeResponse[]>> {
    return this.http.get<ProcurementApiResponse<ProcurementPurchaseOrderTypeResponse[]>>(this.typesUrl, { params: { active } });
  }

  getType(id: number): Observable<ProcurementApiResponse<ProcurementPurchaseOrderTypeResponse>> {
    return this.http.get<ProcurementApiResponse<ProcurementPurchaseOrderTypeResponse>>(`${this.typesUrl}/${id}`);
  }

  getTypeByCode(code: string): Observable<ProcurementApiResponse<ProcurementPurchaseOrderTypeResponse>> {
    return this.http.get<ProcurementApiResponse<ProcurementPurchaseOrderTypeResponse>>(`${this.typesUrl}/code/${encodeURIComponent(code)}`);
  }

  list(filters: { page: number; size: number; search?: string; startDate?: string; endDate?: string; companyId?: number; orderTypeId?: number }): Observable<ProcurementApiResponse<ProcurementPurchaseOrderPageResponse>> {
    return this.http.post<ProcurementApiResponse<ProcurementPurchaseOrderPageResponse>>(`${this.ordersUrl}/page`, filters);
  }

  listAll(): Observable<ProcurementApiResponse<ProcurementPurchaseOrderResponse[]>> {
    return this.http.get<ProcurementApiResponse<ProcurementPurchaseOrderResponse[]>>(this.ordersUrl);
  }

  get(id: number): Observable<ProcurementApiResponse<ProcurementPurchaseOrderResponse>> {
    return this.http.get<ProcurementApiResponse<ProcurementPurchaseOrderResponse>>(`${this.ordersUrl}/${id}`);
  }

  getByCode(code: string): Observable<ProcurementApiResponse<ProcurementPurchaseOrderResponse>> {
    return this.http.get<ProcurementApiResponse<ProcurementPurchaseOrderResponse>>(`${this.ordersUrl}/code/${encodeURIComponent(code)}`);
  }

  create(request: ProcurementPurchaseOrderRequest): Observable<ProcurementApiResponse<ProcurementPurchaseOrderResponse>> {
    return this.http.post<ProcurementApiResponse<ProcurementPurchaseOrderResponse>>(this.ordersUrl, request);
  }

  update(id: number, request: ProcurementPurchaseOrderRequest): Observable<ProcurementApiResponse<ProcurementPurchaseOrderResponse>> {
    return this.http.put<ProcurementApiResponse<ProcurementPurchaseOrderResponse>>(`${this.ordersUrl}/${id}`, request);
  }

  changeStatus(id: number, statusId: number): Observable<ProcurementApiResponse<ProcurementPurchaseOrderResponse>> {
    return this.http.patch<ProcurementApiResponse<ProcurementPurchaseOrderResponse>>(`${this.ordersUrl}/${id}/status/${statusId}`, null);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.ordersUrl}/${id}`);
  }
}
